export default "__VITE_ASSET__7431a821__"